import type { IPedidoDetalhe } from "interfaces/loja/pedido";

/**
 * Normaliza o corpo da GET /loja/pedidos/:id (gerenciar).
 * Aceita `{ data: pedido }`, pedido na raiz ou `{ pedido: ... }`.
 */
export function extractPedidoDetalheResponse(
  payload: unknown
): IPedidoDetalhe | null {
  if (!payload || typeof payload !== "object") return null;
  const root = payload as Record<string, unknown>;

  const tryAsPedido = (v: unknown): IPedidoDetalhe | null => {
    if (!v || typeof v !== "object") return null;
    const o = v as Record<string, unknown>;
    if (typeof o.id === "string") {
      const itens = Array.isArray(o.itens) ? o.itens : [];
      return { ...o, itens } as unknown as IPedidoDetalhe;
    }
    return null;
  };

  const inner = root.data;
  if (inner && typeof inner === "object") {
    const direct = tryAsPedido(inner);
    if (direct) return direct;
    const nested = (inner as Record<string, unknown>).data;
    const fromNested = tryAsPedido(nested);
    if (fromNested) return fromNested;
  }

  const flat = tryAsPedido(root);
  if (flat) return flat;

  const pedido = root.pedido;
  return tryAsPedido(pedido);
}

export function messageFromApiError(
  payload: unknown,
  fallback: string
): string {
  if (!payload || typeof payload !== "object") return fallback;
  const e = (payload as Record<string, unknown>).error;
  if (typeof e === "string" && e.trim()) return e;
  const m = (payload as Record<string, unknown>).message;
  if (typeof m === "string" && m.trim()) return m;
  return fallback;
}
